<h1 mat-dialog-title dir="rtl">פרטים נוספים</h1>

<div class="product-detail__item-more-block">
	<ng-container *ngIf="reverseProductExtraInfoOrder">
		<div class="product-detail__item-more-block-row row" *ngFor="let cp of data.CommentsProduct">
			<div class="product-detail__item-more-block-title">{{ cp.HeadLineStr }}</div>
			<div class="product-detail__item-more-block-text">{{ cp.DataLineStr }}</div>
			<div class="product-detail__item-more-block-text">
				<a href="{{ cp.IfUrl }}" target="_blank" rel="noopener noreferrer">{{ cp.IfUrl }}</a>
			</div>
		</div>
	</ng-container>
	<div class="product-detail__item-more-block-row row" *ngIf="product.Unit">
		<div class="product-detail__item-more-block-title">{{ product.ItemPack }} באריזה</div>
		<div class="product-detail__item-more-block-text">{{ product.Unit }}</div>
	</div>
	<div class="product-detail__item-more-block-row row" *ngIf="data.ShowProfit === '1' || data.ShowProfit === '2'">
		<div class="product-detail__item-more-block-title">רווחיות שורה</div>
		<div class="product-detail__item-more-block-text">
			{{ product.NetPrice | profitCalc : product.CPP : data.ShowProfit | number : '1.0-2' : 'en-US' }}
		</div>
	</div>
	<div class="product-detail__item-more-block-row row" *ngIf="product.NumOfTimes">
		<div class="product-detail__item-more-block-title">תאריך אחרון שנקנה</div>
		<div class="product-detail__item-more-block-text">{{ product.DocCreateDateDisplay }}</div>
	</div>
	<div class="product-detail__item-more-block-row row" *ngIf="product.DocNetPrice">
		<div class="product-detail__item-more-block-title">מחיר אחרון</div>
		<div class="product-detail__item-more-block-text">{{ product.DocNetPrice | number : '1.0-2' : 'en-US' }}</div>
	</div>
	<div class="product-detail__item-more-block-row row" *ngIf="hasDocQuantity">
		<div class="product-detail__item-more-block-title">כמות אחרונה</div>
		<div class="product-detail__item-more-block-text">{{ product.docquantity | number : '1.0-2' : 'en-US' }}</div>
	</div>
	<div class="product-detail__item-more-block-row row">
		<div class="product-detail__item-more-block-title">מספר פעמים שנקנה</div>
		<div class="product-detail__item-more-block-text">{{ product.NumOfTimes }}</div>
	</div>
	<div class="product-detail__item-more-block-row row" *ngIf="product.BM !== 3 && product.BM !== 4 && _ss.CustomerInformation.HideMinPrice === '0'">
		<div class="product-detail__item-more-block-title">מחיר מינימום</div>
		<div class="product-detail__item-more-block-text">{{ product.MinPrice | number : '1.0-2' : 'en-US' }}</div>
	</div>
	<div class="product-detail__item-more-block-row row">
		<div class="product-detail__item-more-block-title">מחלקה</div>
		<div class="product-detail__item-more-block-text">{{ product.IGC }}</div>
	</div>
	<div class="product-detail__item-more-block-row row">
		<div class="product-detail__item-more-block-title">שם סינון</div>
		<div class="product-detail__item-more-block-text">{{ product.ItemExtra1 }}</div>
	</div>
	<div class="product-detail__item-more-block-row row" *ngIf="product.ItemExtra2">
		<div class="product-detail__item-more-block-text">{{ product.ItemExtra2 }}</div>
	</div>
	<div class="product-detail__item-more-block-row row" *ngIf="product.ItemExtra3">
		<div class="product-detail__item-more-block-text">{{ product.ItemExtra3 }}</div>
	</div>
	<div class="product-detail__item-more-block-row row" *ngIf="product.ItemExtra4">
		<div class="product-detail__item-more-block-text">{{ product.ItemExtra4 }}</div>
	</div>
	<div class="product-detail__item-more-block-row row" *ngIf="product.ItemExtra5">
		<div class="product-detail__item-more-block-text">{{ product.ItemExtra5 }}</div>
	</div>

	<ngx-skeleton-loader count="1" appearance="line" *ngIf="data.loadingComments"></ngx-skeleton-loader>

	<ng-container *ngIf="!reverseProductExtraInfoOrder">
		<div class="product-detail__item-more-block-row row" *ngFor="let cp of data.CommentsProduct">
			<div class="product-detail__item-more-block-title">{{ cp.HeadLineStr }}</div>
			<div class="product-detail__item-more-block-text">{{ cp.DataLineStr }}</div>
			<div class="product-detail__item-more-block-text">
				<a href="{{ cp.IfUrl }}" target="_blank" rel="noopener noreferrer">{{ cp.IfUrl }}</a>
			</div>
		</div>
	</ng-container>
	<div class="product-detail__item-more-block-row row" *ngIf="alternativeProductCalculations && product.NetPrice < product.ShowPrice">
		<div class="product-detail__item-more-block-title">הנחה ממחירון</div>
		<div class="product-detail__item-more-block-text">{{ (1 - product.NetPrice / product.ShowPrice) * 100 | number : '1.0-2' }}%</div>
	</div>
</div>
<div mat-dialog-actions dir="rtl">
	<button mat-raised-button (click)="onNoClick()" color="primary">סגור</button>
</div>
